import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import mapi from './api';
import { clearLegacyAuthStorage } from '@/lib/clearLegacyAuthStorage';
import { normalizeArea } from './areas';
import { rememberAppAccount } from './savedAppAccounts';

const MobileCtx = createContext(null);
export const useMobile = () => useContext(MobileCtx);

export function MobileProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [area, setArea] = useState(localStorage.getItem('app_area') || 'privat');
  const [schoolId, setSchoolId] = useState(localStorage.getItem('app_teacher_id') || '');

  const refreshMe = useCallback(async () => {
    try {
      const r = await mapi.get('/app/me');
      setMe(r.data);
      rememberAppAccount(r.data);
      const next = normalizeArea(area, r.data.areas || []);
      if (next && next !== area) {
        setArea(next);
        localStorage.setItem('app_area', next);
      }
    } catch (_e) {
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, [area]);

  useEffect(() => {
    clearLegacyAuthStorage();
    refreshMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (data) => {
    // Cookie set by /app/login|/app/register — do not store access_token
    clearLegacyAuthStorage();
    const meData = data?.me || null;
    setMe(meData);
    if (meData) rememberAppAccount(meData);
    if (meData?.areas?.length) {
      const preferred = localStorage.getItem('app_area');
      const next = normalizeArea(preferred || meData.areas[0], meData.areas);
      setArea(next);
      localStorage.setItem('app_area', next);
    }
  };

  /** Session beenden ohne Redirect — für Konto-/Registrierungswechsel. */
  const endSession = async () => {
    try {
      await mapi.post('/app/logout');
    } catch {
      /* ignore */
    }
    clearLegacyAuthStorage();
    localStorage.removeItem('app_area');
    localStorage.removeItem('app_teacher_id');
    setSchoolId('');
    setMe(null);
  };

  const logout = async () => {
    await endSession();
    window.location.href = '/m/login';
  };

  const switchArea = (a) => { setArea(a); localStorage.setItem('app_area', a); };
  const schools = me?.schools || [];
  const teacherId = schools.some((school) => school.teacher_id === schoolId)
    ? schoolId
    : (me?.teacher_id || schools[0]?.teacher_id || '');
  const switchSchool = (id) => {
    setSchoolId(id);
    localStorage.setItem('app_teacher_id', id);
  };

  return (
    <MobileCtx.Provider value={{
      me, setMe, loading, refreshMe, login, logout, endSession, area, switchArea,
      schools, teacherId, switchSchool,
    }}>
      {children}
    </MobileCtx.Provider>
  );
}
